import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
// const emojiRegex = require("emoji-regex");
// Connects to data-controller="forms"
export default class extends Controller {
  static targets = [
    "changeTrigger",
    "divOptionalFields",
    "changeRadioButtonTrigger",
    "changeCheckboxTrigger",
    "toggleRequired",
    "inputText",
    "displayText",
    "inputToCopy",
    "copyInput",
    "searchedElt",
    "noResult",
    "nbResults",
    "checkbox",
    "selectAll",
    "deselectAll",
    "selectToFilter",
  ];
  static values = { display: String, mandatory: Boolean, required: String, baseUrl: String, frameId: String };

  declare changeTriggerTarget: HTMLInputElement;
  declare changeTriggerTargets: HTMLInputElement[];
  declare hasChangeTriggerTarget: boolean;

  declare divOptionalFieldsTarget: HTMLElement;
  declare hasDivOptionalFieldsTarget: boolean;
  declare displayValue: string;
  declare hasDisplayValue: boolean;
  declare changeRadioButtonTriggerTargets: HTMLInputElement[];
  declare hasChangeRadioButtonTriggerTarget: boolean;
  declare changeCheckboxTriggerTarget: HTMLInputElement;
  declare hasChangeCheckboxTriggerTarget: boolean;
  declare toggleRequiredTarget: HTMLInputElement;
  declare hasToggleRequiredTarget: boolean;
  declare requiredValue: string;
  declare hasRequiredValue: boolean;
  declare mandatoryValue: boolean;
  declare hasMandatoryValue: boolean;
  declare inputTextTarget: HTMLInputElement;
  declare hasInputTextTarget: boolean;
  declare displayTextTarget: HTMLElement;
  declare hasDisplayTextTarget: boolean;
  declare searchedEltTargets: HTMLElement[];
  declare hasSearchedEltTarget: boolean;
  declare noResultTarget: HTMLElement;
  declare hasNoResultTarget: boolean;
  declare nbResultsTarget: HTMLElement;
  declare hasNbResultsTarget: boolean;

  declare htmlFields: string;

  declare inputToCopyTarget: HTMLInputElement;
  declare hasInputToCopyTarget: boolean;
  declare copyInputTarget: HTMLInputElement;
  declare hasCopyInputTarget: boolean;

  declare checkboxTargets: HTMLInputElement[];
  declare hasCheckboxTarget: boolean;
  declare selectAllTarget: HTMLElement;
  declare hasSelectAllTarget: boolean;
  declare deselectAllTarget: HTMLElement;
  declare hasDeselectAllTarget: boolean;

  declare baseUrlValue: string;
  declare hasBaseUrlValue: boolean;
  declare frameIdValue: string;
  declare hasFrameIdValue: boolean;

  declare selectToFilterTarget: HTMLSelectElement;
  declare hasSelectToFilterTarget: boolean;

  connect() {
    if (this.hasDivOptionalFieldsTarget) {
      this.htmlFields = this.divOptionalFieldsTarget.innerHTML;
      this.toggleOptionalFields();
    }
    if (this.hasChangeTriggerTarget && this.hasToggleRequiredTarget) {
      this.toggleRequired();
    }
  }

  toggleOptionalFields() {
    if (!this.hasDivOptionalFieldsTarget) return;

    if (this.hasDisplayValue) {
      if (this.hasChangeTriggerTarget) {
        if (
          ((this.displayValue != "valuePresence" && this.displayValue === this.changeTriggerTarget.value) ||
            (this.displayValue === "valuePresence" && this.changeTriggerTarget.value != "")) &&
          this.divOptionalFieldsTarget.innerHTML === ""
        ) {
          this.divOptionalFieldsTarget.innerHTML = this.htmlFields;
        } else if (
          ((this.displayValue != "valuePresence" && this.displayValue !== this.changeTriggerTarget.value) ||
            (this.displayValue === "valuePresence" && this.changeTriggerTarget.value == "")) &&
          this.divOptionalFieldsTarget.innerHTML !== ""
        ) {
          this.divOptionalFieldsTarget.innerHTML = "";
        }
      } else if (this.hasChangeRadioButtonTriggerTarget) {
        for (let radioButton of this.changeRadioButtonTriggerTargets) {
          if (
            radioButton.value == this.displayValue &&
            radioButton.checked &&
            this.divOptionalFieldsTarget.innerHTML === ""
          ) {
            this.divOptionalFieldsTarget.innerHTML = this.htmlFields;
          } else if (
            radioButton.value != this.displayValue &&
            radioButton.checked &&
            this.divOptionalFieldsTarget.innerHTML !== ""
          ) {
            this.divOptionalFieldsTarget.innerHTML = "";
          }
        }
      }
    } else if (this.hasChangeCheckboxTriggerTarget) {
      this.divOptionalFieldsTarget.innerHTML = this.changeCheckboxTriggerTarget.checked ? "" : this.htmlFields;
    }
  }

  toggleRequired() {
    if (this.hasChangeTriggerTarget && this.hasToggleRequiredTarget) {
      // valeur qui passe la target à required
      const requiredValue = this.hasRequiredValue ? this.requiredValue : "";
      if (this.changeTriggerTargets && this.changeTriggerTargets.length > 1) {
        const allInputsBlank = this.changeTriggerTargets.every((input) => {
          return input.value == "" || input.value == null;
        });
        this.toggleRequiredTarget.required = allInputsBlank;
      } else {
        this.toggleRequiredTarget.required = this.changeTriggerTarget.value == requiredValue;
      }
    } else if (this.hasChangeTriggerTarget && this.changeTriggerTarget.classList.contains("hidden")) {
      this.toggleRequiredTarget.required = false;
    }
  }

  customStep(event) {
    event.preventDefault();
    let value = parseFloat(event.target.value);
    if (event.target.value == "") {
      value = 0;
    }
    // wheelDelta determine si scroll vers le haut (>0) ou vers le bas (<0)
    if (event.wheelDelta > 0) {
      event.target.value = Number.isInteger(value) ? value + 1 : Math.ceil(value);
      event.target.dispatchEvent(new Event("input"));
    } else {
      let newValue = Number.isInteger(value) ? value - 1 : Math.floor(value);
      event.target.value = newValue > 0 ? newValue : 0;
      event.target.dispatchEvent(new Event("input"));
    }
  }

  formatNumberInput(event) {
    let value = parseFloat(event.target.value);
    if (value < 0) {
      event.target.value = 0;
      return;
    }

    let regex_too_much_decimals = /^\d+(\,|\.)\d{3,}$/;
    if (regex_too_much_decimals.test(value.toString())) {
      event.target.value = value.toFixed(2);
      event.target.dispatchEvent(new Event("input"));
    }
  }

  formatInputTextToNumber(event) {
    if (event.target.value != null && event.target.value != "0") {
      let input = event.target.value;
      event.target.value = "";
      for (let char of input) {
        if (/^\d$/.test(char)) {
          event.target.value += char;
        }
      }
      let min = event.target.min == "" ? 0 : parseInt(event.target.min);
      let max = event.target.max == "" ? null : parseInt(event.target.max);
      let quantity = event.target.value == "" ? 0 : parseInt(event.target.value);
      if (quantity < min) {
        event.target.value = min.toString();
      } else if (max && quantity > max) {
        event.target.value = max.toString();
      }
    }
  }

  increment() {
    if (this.hasInputTextTarget) {
      let max = this.inputTextTarget.max == "" ? null : parseInt(this.inputTextTarget.max);
      let quantity = this.inputTextTarget.value == "" ? 0 : parseInt(this.inputTextTarget.value);

      this.inputTextTarget.value =
        (max != null && quantity < max) || max == null ? (quantity + 1).toString() : max.toString();
      this.inputTextTarget.dispatchEvent(new Event("input"));
    }
  }

  decrement() {
    if (this.hasInputTextTarget) {
      let min = this.inputTextTarget.min == "" ? 0 : parseInt(this.inputTextTarget.min);
      let quantity = this.inputTextTarget.value == "" ? 0 : parseInt(this.inputTextTarget.value);
      if (quantity > min) {
        this.inputTextTarget.value = (quantity - 1).toString();
        this.inputTextTarget.dispatchEvent(new Event("input"));
      }
    }
  }

  increment_or_decrement(event) {
    if (this.hasInputTextTarget) {
      this.inputTextTarget.value = event.target.value && event.target.value != "" ? "1" : "";
      this.inputTextTarget.dispatchEvent(new Event("input"));
    }
  }

  resetForm(event) {
    const inputs = this.element.getElementsByTagName("input");
    for (let input of inputs) {
      if (input != event.target) {
        input.value = "";
      }
    }
  }

  copyInput() {
    if (
      this.hasInputToCopyTarget &&
      this.hasCopyInputTarget &&
      this.inputToCopyTarget.value != "" &&
      (this.copyInputTarget.value == null || this.copyInputTarget.value == "")
    ) {
      this.copyInputTarget.value = this.inputToCopyTarget.value;
    }
  }

  search(event) {
    if (this.hasSearchedEltTarget) {
      let input = event.target.value.trim().toLowerCase();
      let nbResults = 0;

      if (input && input != "") {
        this.searchedEltTargets.forEach((elt) => {
          // Si chiffres on cherche sur no dossard
          if (input.match(/\d+/g)) {
            if (elt.dataset.number?.startsWith(input)) {
              elt.classList.remove("hidden");
              nbResults += 1;
            } else {
              elt.classList.add("hidden");
            }
            //  sinon sur nom prénom
          } else {
            if (elt.dataset.name?.includes(input)) {
              elt.classList.remove("hidden");
              nbResults += 1;
            } else {
              elt.classList.add("hidden");
            }
          }
        });
      } else {
        this.searchedEltTargets.forEach((elt) => {
          elt.classList.remove("hidden");
          nbResults += 1;
        });
      }
      if (this.searchedEltTargets.every((elt) => elt.classList.contains("hidden")) && this.hasNoResultTarget) {
        this.noResultTarget.classList.remove("hidden");
        if (this.hasNbResultsTarget) {
          this.nbResultsTarget.innerText = "0";
        }
      } else {
        this.noResultTarget.classList.add("hidden");
        if (this.hasNbResultsTarget) {
          this.nbResultsTarget.innerText = nbResults.toString();
        }
      }
    }
  }

  generateRandomCode() {
    const chars = "ABCDEFGHJKMNPQRSTUVWXYZ123456789";
    const length = Math.floor(Math.random() * 5) + 16; // Valeur entre 16 et 20 inclus
    const regex = /^(?=(?:[^1-9]*[1-9]){2,8})[A-HJ-KM-NP-Z1-9]{16,}$/;
    let code = "";
    while (!regex.test(code)) {
      code = "";
      for (let i = 0; i < length; i++) {
        code += chars[Math.floor(Math.random() * chars.length)];
      }
    }
    if (this.hasInputTextTarget) {
      this.inputTextTarget.value = code;
    }
    if (this.hasDisplayTextTarget) {
      this.displayTextTarget.innerText = code;
    }
  }

  // Appelé sur des inputs pour soumission du formulaire à chaque changement
  autosubmit(event) {
    const form = event.target.form;
    if (event.target.checked && event.target.classList.contains("alone_checkbox")) {
      this.uncheckedOthers(event.target);
    }
    form.submit();
    const spinner = document.getElementById("spinner");
    if (spinner) {
      spinner.classList.remove("hidden");
    }
  }

  uncheckedOthers(checkbox) {
    let others =
      checkbox.dataset.checkboxAsRadioName == undefined
        ? this.element.querySelectorAll(`[name='${checkbox.name}'`)
        : this.element.querySelectorAll(`[data-checkbox-as-radio-name='${checkbox.dataset.checkboxAsRadioName}'`);
    others.forEach((cb) => {
      if (cb.checked && (cb.value != checkbox.value || cb.id != checkbox.id)) {
        cb.checked = false;
        cb.dispatchEvent(new Event("change", { bubbles: true }));
        if (this.element.id != "itemCards") return;
        this.toggleLabelStyle(cb);
      }
    });
  }

  toggleLabelStyle(targetInput: HTMLInputElement) {
    let label;
    if (targetInput.labels != undefined) {
      label = targetInput.labels[0];
    }
    if (label != null) {
      let container = label.getElementsByClassName("container")[0];
      let circle = label.getElementsByClassName("circle")[0];
      let colorValue = this.element.dataset.subscriptionColorValue;
      const containerBaseClass = container.className.replace(/border-[a-z]+/g, "");
      const circleBaseClass = circle.className.replace(/bg-[a-z]+/g, "");
      const check =
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/></svg>';
      if (targetInput.checked) {
        container.className = containerBaseClass + ` border${colorValue}`;
        if (circle != null) {
          circle.className = circleBaseClass + ` bg${colorValue}`;
          circle.innerHTML = check;
        }
      } else {
        container.className = containerBaseClass + " border-transparent";
        if (circle != null) {
          circle.className = circleBaseClass + ` border${colorValue} border-2`;
          circle.innerHTML = "";
        }
      }
    }
  }

  checkboxAsRadio(event) {
    if (!event.target.checked) return;
    this.uncheckedOthers(event.target, event);
  }

  toggleAllCheckboxes(event) {
    if (this.hasCheckboxTarget) {
      this.checkboxTargets.forEach((cb) => {
        cb.checked = event.target == this.selectAllTarget;
        cb.dispatchEvent(new Event("change", { bubbles: true }));
      });
      if (this.hasSelectAllTarget) this.selectAllTarget.classList.toggle("hidden");
      if (this.hasDeselectAllTarget) this.deselectAllTarget.classList.toggle("hidden");
    }
  }

  selectAndVisit(event) {
    if (this.hasBaseUrlValue && this.hasFrameIdValue) {
      let option = event.target.selectedOptions[0];
      let url = option.dataset.url || this.baseUrlValue;
      Turbo.visit(url, { frame: this.frameIdValue });
    }
  }

  filterSelectOptions(event) {
    if (!this.hasSelectToFilterTarget) return;
    Array.from(this.selectToFilterTarget.selectedOptions).forEach((opt) => {
      opt.selected = false;
    });
    if (event.target.value == "" || event.target.value == null) {
      this.selectToFilterTarget.parentElement?.classList.add("hidden");
    } else {
      Array.from(this.selectToFilterTarget.options).forEach((opt) => {
        if (opt.dataset.elementId == event.target.value) {
          opt.classList.remove("hidden");
        } else {
          opt.classList.add("hidden");
        }
      });
      this.selectToFilterTarget.parentElement?.classList.remove("hidden");
    }
  }
}
